import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Gauge, Zap, Calendar } from "lucide-react";
import { motion } from "framer-motion";
import { resolveImageUrl } from "../../lib/api";

const money = (n) => `$${n.toLocaleString()}`;

export default function VehicleCard({ vehicle, index = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.5, delay: index * 0.05, ease: [0.2, 0.8, 0.2, 1] }}
    >
      <Link
        to={`/vehicle/${vehicle.id}`}
        data-testid={`vehicle-card-${vehicle.id}`}
        className="vehicle-card block group"
      >
        <div className="img-wrap aspect-[4/3] bg-[#111]">
          {vehicle.images?.[0] && (
            <img
              src={resolveImageUrl(vehicle.images[0])}
              alt={`${vehicle.make} ${vehicle.model}`}
              className="w-full h-full object-cover"
              loading="lazy"
            />
          )}
        </div>
        <div className="p-5">
          <div className="flex items-start justify-between gap-4">
            <div>
              <div className="overline text-white/40">{vehicle.year} · {vehicle.body_type}</div>
              <h3 className="font-display text-2xl mt-1 tracking-tight leading-none">{vehicle.make}</h3>
              <div className="text-white/80 text-sm mt-1">{vehicle.model}</div>
            </div>
            <div className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center group-hover:border-[var(--primary)] group-hover:bg-[var(--primary)] transition-colors">
              <ArrowUpRight size={14} />
            </div>
          </div>
          <div className="flex items-center gap-4 mt-4 text-xs text-white/50">
            <span className="inline-flex items-center gap-1"><Gauge size={12} /> {vehicle.mileage.toLocaleString()} mi</span>
            <span className="inline-flex items-center gap-1"><Zap size={12} /> {vehicle.horsepower} hp</span>
            <span className="inline-flex items-center gap-1"><Calendar size={12} /> {vehicle.year}</span>
          </div>
          <div className="mt-5 pt-4 border-t border-white/5 flex items-baseline justify-between">
            <div className="overline">Price</div>
            <div className="font-display text-2xl text-white">{money(vehicle.price)}</div>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
